import React from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Features } from './components/features'
import { Gallery } from './components/gallery'
import { About } from './components/about'
import { SocialProof } from './components/socialproof'
import { Footer } from './components/footer'
import SmoothScroll from 'smooth-scroll'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const dividerStyle = {
  height: '1px',
  border: 0,
  width: '90%',
  maxWidth: '900px',
  margin: '0 auto',
  background: 'linear-gradient(to right, transparent, rgba(255,212,81,0.25), transparent)',
}

const Divider = () => <hr style={dividerStyle} aria-hidden='true' />

const App = () => {
  return (
    <div style={{
      backgroundColor: '#1c2a35'
    }}>
      <Navigation  />
      <Header  />
      <main>
        <div style={{
          backgroundImage: 'url(/img/background_rotate.webp)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}>
          <Features />
          <Divider />
          <About />
          <Divider />
          <SocialProof />
          <Divider />
          <Gallery />
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default App
